// extracted by mini-css-extract-plugin
module.exports = {"reviewtabMinWidth":"415px","button":"i_DzYE","AniFadeIn":"b2TKgL","AniFadeOut":"a4QxcS","AniRotate":"Qt0x8q","AniPlaceholderFadeOut":"PvVWym"};